//#region src/credentialVendor.ts
/**
* Vendors whose accounts are provisioned by the customer, and whose per-tenant secrets
* exist in Secret Manager today.
*
* Membership is what makes a vendor's credentials per-tenant, so a vendor belongs here
* only once every tenant that uses it has its own `${slug}-${vendor}-*` secrets. Adding
* one before those secrets exist fails that vendor's jobs for every tenant that lists
* it, because there is no shared fallback by design. Development boot throws
* if any required name is missing. Production does not probe; that tenant's
* jobs fail at getVendorSecret.
*
* Vendors we provision ourselves — Anthropic, Vogent, Vapi, Retell, Libretto, auth —
* will never appear here. One account shared by every tenant is correct for those rather
* than a bug, so they stay `Secret` enum members permanently under the `global`
* scope (`global-anthropic-api-key`). See docs/tenant-credentials.md.
*
* The values double as the vendor segment of every secret name, so renaming a member
* renames secrets in GCP.
*
* Lives in its own module so tenant manifests can import the enum without a cycle
* through vendorCredentials (which reads vendors from getTenantManifest).
*/
let CredentialVendor = /* @__PURE__ */ function(CredentialVendor) {
	CredentialVendor["Athena"] = "athena";
	CredentialVendor["Availity"] = "availity";
	CredentialVendor["Azalea"] = "azalea";
	CredentialVendor["Spruce"] = "spruce";
	CredentialVendor["UHC"] = "uhc";
	return CredentialVendor;
}({});
/**
* Every field Secret Manager must hold for a vendor once that vendor is registered for
* a tenant. The strings are the field segment of `${slug}-${vendor}-${field}`.
*
* Adding a field here is what makes the startup check require it. Fetch sites should use
* the same strings so a rename cannot leave the checker and the fetcher disagreeing.
*/
const VENDOR_FIELDS = {
	[CredentialVendor.Athena]: [
		"url",
		"username",
		"password",
		"otp-code"
	],
	[CredentialVendor.Availity]: [
		"user-id",
		"password",
		"otp-code"
	],
	[CredentialVendor.Azalea]: [
		"username",
		"password",
		"otp-code"
	],
	[CredentialVendor.Spruce]: ["production-api-key"],
	[CredentialVendor.UHC]: [
		"username",
		"password",
		"otp-code"
	]
};

//#endregion
export { CredentialVendor, VENDOR_FIELDS };